import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import DashboardPage from "./components/DashboardPage";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const options = {
  method: "post",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  }
};

const urls = {
  lockerservice: "api/locker.php",
  translator: "api/translator.php",
};

const secret = {
  site: "",
  items: null
}

const validateMessage = {
  requiredBoxService: "กรุณาระบุโครงการ",
  requiredRoomNo: "กรุณาระบุเลขห้อง",
  roomNoFormat: "กรุณาระบุเลขห้องให้ถูกต้อง Ex. 123/456",
  requiredPhoneNoReceiver: "กรุณาระบุเบอร์มือถือผู้รับ",
  phoneNoReceiverFormat: "กรุณาระบุเบอร์มือถือผู้รับให้ถูกต้อง Ex. 0865881614",
  requiredPhoneNoSender: "กรุณาระบุเบอร์มือถือผู้ส่ง",
  phoneNoSenderFormat: "กรุณาระบุเบอร์มือถือผู้ส่งให้ถูกต้อง Ex. 0865881614",
  otpNotMatch: "OTP ไม่ถูกต้อง"
};

const phonePattern = /[0][689]\d{1}[-]\d{3}[-]\d{4}/;
const roomPatternA = /^((([a-zA-Z]|\d)+)(\/)(\d+))$/;
const roomPatternB = /^(([a-zA-Z]|\d)+)$/;
const rules = {
  requiredBoxService: (value) => !!value || validateMessage.requiredBoxService,
  requiredRoomNo: (value) => !!value || validateMessage.requiredRoomNo,
  roomNoFormat: (value) => {
    return (
      roomPatternA.test(value) ||
      roomPatternB.test(value) ||
      validateMessage.roomNoFormat
    );
  },
  requiredPhoneNoReceiver: (value) =>
    !!value || validateMessage.requiredPhoneNoReceiver,
  phoneNoReceiverFormat: (value) => {
    return phonePattern.test(value) || validateMessage.phoneNoReceiverFormat;
  },
  requiredPhoneNoSender: (value) =>
    !!value || validateMessage.requiredPhoneNoSender,
  phoneNoSenderFormat: (value) => {
    return phonePattern.test(value) || validateMessage.phoneNoSenderFormat;
  },
  otpValidate: (value, otp) => {
    return value == otp || validateMessage.otpNotMatch;
  }
};

const routes = [
  {
    path: "/",
    component: DashboardPage,
    props: {
      rules: rules,
      options: options,
      urlLockerService: urls.lockerservice,
      urlTranslatorService: urls.translator,
      secret: secret,
    },
  }
];

const router = new VueRouter({
  routes
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount("#app");
